<template>
  <main class="main">
    <div class="anim-wrap" :class="{ loading: loading }">
      <div class="container">
        <div class="row page-nav">
          <div class="col-md-8 hidden-sm">
            <nav class="breadcrumbs">
              <ol v-if="groupData" class="breadcrumb">
                <li>
                  <router-link to="/" class="link-item">Dashboard</router-link>
                </li>
                <li v-if="groupData">
                  <router-link
                    class="link-item"
                    :to="'/view/?group=' + groupData.id"
                  >
                    {{ groupData.groupName }}</router-link
                  >
                </li>
                <li><span class="link-item">Edit group details</span></li>
              </ol>
              <ol v-else class="breadcrumb">
                <li>
                  <router-link to="/" class="link-item">Dashboard</router-link>
                </li>
                <li><span class="link-item">Create new group</span></li>
              </ol>
            </nav>
          </div>
          <div class="col-md-4 text-md-right">
            <router-link to="/" class="link-item"
              ><font-awesome-icon icon="angle-left" /> Back to
              Dashboard</router-link
            >
          </div>
        </div>
        <div v-if="groupData" class="row">
          <div class="col-12 mb-5">
            <h1>Edit group: {{ groupData.groupName }}</h1>
            <h4 class="color-grey">{{ getOrganisationData.name }}</h4>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-12 mb-5">
            <h1>Create a new group</h1>
            <h4 class="color-grey">{{ getOrganisationData.name }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="content-panel padded">
              <div class="row">
                <div class="col-md-8">
                  <h4>Group name</h4>
                  <b-form-input
                    class="input-big"
                    v-model="groupName"
                    maxlength="70"
                    id="groupName"
                    :state="nameValidation"
                    v-on:blur="validateName()"
                    placeholder="Group name"
                  ></b-form-input>
                  <b-form-invalid-feedback id="groupName">
                    Enter at least 4 letters
                  </b-form-invalid-feedback>

                  <h4>Tests included</h4>
                  <b-form-checkbox
                    v-model="includeInsights"
                    class="checkbox-big"
                    name="includeInsights"
                  >
                    <span class="checkbox-title">Insights</span>
                    <span class="checkbox-subtitle">Personality test</span>
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-model="includePathways"
                    class="checkbox-big"
                    name="includePathways"
                  >
                    <span class="checkbox-title">Pathways</span>
                    <span class="checkbox-subtitle"
                      >Interest based job matches</span
                    >
                  </b-form-checkbox>
                  <h4 class="mt-4">Reading age</h4>
                  <b-form-group>
                    <b-form-radio
                      class="radio-big"
                      v-model="testLanguage"
                      name="testLanguage"
                      value="default"
                      ><span class="radio-title">Default</span>
                      <span class="radio-subtitle"
                        >Default reading age
                      </span></b-form-radio
                    >
                    <b-form-radio
                      class="radio-big"
                      v-model="testLanguage"
                      name="testLanguage"
                      value="reduced"
                      ><span class="radio-title">Reduced</span>
                      <span class="radio-subtitle"
                        >Reduced reading age
                      </span></b-form-radio
                    >
                  </b-form-group>
                  <h4 class="mt-4">Group settings</h4>
                  <b-form-checkbox
                    v-model="reportAccess"
                    class="checkbox-big"
                    name="reportAccess"
                  >
                    <span class="checkbox-title">Enable Report Access</span>
                    <span class="checkbox-subtitle"
                      >Let candidates access their reports</span
                    >
                  </b-form-checkbox>
                  <h4 class="mt-4">
                    Group admin email
                    <span style="font-weight: normal; font-size: 0.8em;"
                      >(optional, visible to users)</span
                    >
                  </h4>
                  <b-form-input
                    v-model="adminEmail"
                    id="adminEmail"
                    placeholder="Email address"
                  ></b-form-input>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <hr />
                </div>
              </div>
              <div v-if="groupData" class="row footer-action">
                <div class="col-md-6">
                  <button
                    class="btn btn-link btn-delete"
                    @click="promptDeleteGroup()"
                  >
                    Delete group
                  </button>
                </div>
                <div class="col-md-6 text-md-right">
                  <router-link to="/" class="btn btn-link">Cancel</router-link>
                  <button class="btn btn-primary" @click="saveGroup()">
                    Save changes
                  </button>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-md-6 my-auto"></div>
                <div class="col-md-6 text-md-right">
                  <router-link to="/" class="btn btn-link">Cancel</router-link>
                  <button class="btn btn-primary" @click="createGroup()">
                    Create group
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapState } from "vuex";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      isEdit: false,
      loading: false,
      performanceOpen: false,
      nameValidation: null,
      groupName: null,
      workforceOpen: false,
      includeInsights: true,
      includePathways: true,
      reportAccess: false,
      adminEmail: null,
      testLanguage: "default",
    };
  },
  props: {
    groupData: Object,
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["userPrivateData"]),
    ...mapState(["organisationData"]),
    ...mapState(["groupsData"]),
    getUserPrivateData() {
      return this.userPrivateData ? this.userPrivateData : "";
    },
    getUser() {
      return this.user ? this.user : "";
    },
    getGroupsData() {
      return this.groupsData ? this.groupsData : "";
    },
    getOrganisationData() {
      return this.organisationData ? this.organisationData : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    nameState() {
      return this.nameValidation;
    },
    totalTestsCompleted() {
      let total = 0;
      if (this.getGroupsData) {
        this.getGroupsData.forEach((group) => {
          group.users.forEach((user) => {
            if (user.insights) {
              total++;
            }
            if (user.pathways) {
              total++;
            }
          });
        });
      }
      return total;
    },
    totalUsers() {
      let total = 0;
      if (this.getGroupsData) {
        this.getGroupsData.forEach((group) => {
          group.users.forEach(() => {
            total++;
          });
        });
      }
      return total;
    },
  },
  mounted() {
    if (this.groupData) {
      this.isEdit = true;
      this.staticGroupName = this.groupData.groupName;
      this.groupName = this.groupData.groupName;
      this.includeInsights = this.groupData.includeInsights;
      this.includePathways = this.groupData.includePathways;
      this.reportAccess = this.groupData.reportAccess;
      if (this.groupData.adminEmail) {
        this.adminEmail = this.groupData.adminEmail;
      }
      if (this.groupData.testLanguage) {
        this.testLanguage = this.groupData.testLanguage;
      }
    }
  },
  methods: {
    validateName() {
      if (
        this.groupName === null ||
        this.groupName.length < 4 ||
        this.groupName.length > 70
      ) {
        this.nameValidation = false;
      } else if (this.groupName.length > 3) {
        this.nameValidation = true;
      }
      return this.nameValidation;
    },
    promptDeleteGroup() {
      let options = {
        html: true,
        okText: "Delete group",
        cancelText: "Cancel",
        type: "hard",
        verification: "confirm",
        verificationHelp: 'Type "[+:verification]" below to confirm',
      };
      let message =
        "You are about to delete the group <b>" +
        this.groupData.groupName +
        "</b> including all the userdata and testdata tied to this group. All the information will be lost and this action can not be reversed. Are you sure you want to delete this group?";
      this.$dialog
        .confirm(message, options)
        .then(() => {
          this.deleteGroup();
        })
        .catch(() => {});
    },
    saveGroup() {
      if (!this.validateName()) {
        return false;
      }

      this.loading = true;
      let saveGroup = firebase.functions().httpsCallable("saveGroup");

      saveGroup({
        groupId: this.groupData.id,
        groupName: this.groupName,
        includeInsights: this.includeInsights,
        includePathways: this.includePathways,
        reportAccess: this.reportAccess,
        testLanguage: this.testLanguage,
        adminEmail: this.adminEmail,
      })
        .then(() => {
          this.loading = false;
          this.$toast.open({
            message: "Group saved succesfully",
            type: "success",
          });
          this.$router.replace("/");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteGroup() {
      this.loading = true;
      let deleteGroup = firebase.functions().httpsCallable("deleteGroup");

      deleteGroup({
        groupId: this.groupData.id,
      })
        .then((result) => {
          this.loading = false;
          this.$toast.open({
            message:
              "Group and " + result.data.users + " users removed succesfully",
            type: "success",
          });
          this.$router.replace("/");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createGroup() {
      if (!this.validateName()) {
        return false;
      }

      this.loading = true;
      let createGroup = firebase.functions().httpsCallable("createGroup");

      createGroup({
        groupName: this.groupName,
        includeInsights: this.includeInsights,
        includePathways: this.includePathways,
        reportAccess: this.reportAccess,
        testLanguage: this.testLanguage,
        adminEmail: this.adminEmail,
      })
        .then((result) => {
          if (result.data.id) {
            this.loading = false;
            this.$toast.open({
              message: "New group " + this.groupName + " created succesfully",
              type: "success",
            });
            this.$router.push({
              path: "/view/?group=" + result.data.id,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
